import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { EmbedTokenType } from '../../enums/embedTokenType.enum';

export const embedTokenGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
	const router = inject(Router);
	const userService = inject(UserService);

	const token = route?.queryParams?.['token'];
	if (!token) {
		return router.parseUrl('/embed-token-expired');
	}

	try {
		const claims = await userService.validateEmbedToken(token);
		const expectedType = route.data?.['embedTokenType'] as EmbedTokenType | undefined;
		if (expectedType && claims?.type !== expectedType) {
			return router.parseUrl('/embed-token-expired');
		}
		route.data = { ...route.data, readonly: claims?.readonly ?? true };
		return true;
	} catch {
		return router.parseUrl('/embed-token-expired');
	}
};
